import React from "react";
import { makeIconDef } from "./makeIconDef";
export var GridIconDef = {
    'grid': makeIconDef('grid', {
        regular: function () { return React.createElement(React.Fragment, null,
            React.createElement("rect", { x: "4.5", y: "4.5", width: "6", height: "6", stroke: "currentColor" }),
            React.createElement("rect", { x: "4.5", y: "13.5", width: "6", height: "6", stroke: "currentColor" }),
            React.createElement("rect", { x: "13.5", y: "4.5", width: "6", height: "6", stroke: "currentColor" }),
            React.createElement("rect", { x: "13.5", y: "13.5", width: "6", height: "6", stroke: "currentColor" })); },
        filled: function () { return React.createElement(React.Fragment, null,
            React.createElement("rect", { x: "4", y: "4", width: "7", height: "7", fill: "currentColor" }),
            React.createElement("rect", { x: "4", y: "13", width: "7", height: "7", fill: "currentColor" }),
            React.createElement("rect", { x: "13", y: "4", width: "7", height: "7", fill: "currentColor" }),
            React.createElement("rect", { x: "13", y: "13", width: "7", height: "7", fill: "currentColor" })); }
    })
};
